export type Cell = [x: number, y: number];

export const key = (x: number, y: number): string => `${x},${y}`;
export const unkey = (k: string): Cell => {
  const [x = 0, y = 0] = k.split(",").map(Number);
  return [x, y];
};
export const sleep = (ms: number): Promise<void> => new Promise((r) => setTimeout(r, ms));
export const clamp = (v: number, a: number, b: number): number => Math.max(a, Math.min(b, v));

/** A value that is either static or computed from current game state. */
export type Dyn<T> = T | (() => T);
export const resolve = <T>(v: Dyn<T>): T => (typeof v === "function" ? (v as () => T)() : v);
